var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',[_c('HtmlImage',{attrs:{"isEdit":true,"src":_vm.node.attrs.src},on:{"click-image":_vm.openImagePanel}}),_c('InputImageAttrWidget',{ref:"inputImageAttrItem",attrs:{"isDelete":true},on:{"delete":_vm.onDeleteImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }